/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import ROUTES from 'modules/common/constants/route';
import { selectTokenRevocation } from 'modules/common/auth/selectors';
/**
 * Pop up common component that uses across modules for display session timeout messages
 */
const TokenRevokedPopup = () => {
  const navigate = useNavigate();
  const isTokenRevoked = useSelector(selectTokenRevocation);
  //
  return (
    <Dialog
      open={isTokenRevoked ?? false}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      sx={{ borderRadius: 50 }}
    >
      <DialogTitle id="alert-dialog-title" sx={{ textAlign: 'center' }}>
        Session Expired!
      </DialogTitle>
      <DialogContent id="alert-dialog-description" sx={{ textAlign: 'center', mx: 10 }}>
        You have been forcefully logged out from the system. Please login again to continue working.
      </DialogContent>
      <DialogActions
        sx={{
          justifyContent: 'space-around',
          pb: 5,
        }}
      >
        <Button
          sx={{ px: 10 }}
          autoFocus
          variant="contained"
          onClick={() => navigate(ROUTES.LOGIN)}
        >
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};
//
export default TokenRevokedPopup;
